import "./Header.css";
import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import Vtheaderright from "./Headercomponent/Vtheaderright";
import { getToken, removeToken, storeToken } from "../services/LocalStorageSrv";
import axios from "axios";
import Loader from "../Loader";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Header = ({
  loginpopRef,
  newpop,
  newpop2,
  newpop3,
  signup,
  matchotps,
  forgotpotp,
  emailmsg,
  fromemailnextpopup,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const tokendata = getToken("data");
  const nvg = useNavigate();

  // ─── Refs ────────────────────────────────────────────────────────────────────
  const closeretriveaccess = useRef(null);
  const closefromemailnextpopup = useRef(null);
  const matchotp = useRef(null);
  const verifyotp = useRef(null);
  // FIX #1: single ref for the countdown interval — prevents stacking multiple timers
  const timerRef = useRef(null);

  // ─── Core UI state ───────────────────────────────────────────────────────────
  const [cartitemscount, setCartItemCount] = useState([]);
  const [loading, setLoading] = useState(true);
  const [login, setlogin] = useState(false);
  const [changepss, setchangepss] = useState(false);
  const [data, setUserData] = useState(null);
  const [catalogUrl, setCatalogUrl] = useState(null);
  const [showInactiveModal, setShowInactiveModal] = useState(false);

  // ─── Login form ──────────────────────────────────────────────────────────────
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [botherror, setBothError] = useState("");
  const [error, setError] = useState("");
  const [erroremail, seterroremail] = useState("");
  const [errorpassword, seterrorpassword] = useState("");

  // ─── Retrieve / forgot flow ──────────────────────────────────────────────────
  const [exitsvendor_code, setvendor_code] = useState("");
  const [mobilenumber, setMobileNumner] = useState("");
  const [errors, setErrors] = useState({});
  const [RetriveAndForgot, setRetriveAndForgot] = useState("");
  const [selectedValue, setSelectedValue] = useState("mobile");
  const [formData, setFormData] = useState({
    vendor_code: "",
    country: "",
    mobile: "",
    email: "",
    otp: "",
  });

  // ─── OTP state ───────────────────────────────────────────────────────────────
  const [otpSent, setOtpSent] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState(180);
  // FIX #2: guard flag — blocks duplicate API calls from rapid clicks or stacked timers
  const [isSending, setIsSending] = useState(false);
  const [otpmessage, setotpmessage] = useState("");
  const [error_otp_match, seterror_otp_match] = useState("");

  // ─── Popup visibility ────────────────────────────────────────────────────────
  const [openotppopup, setopenotppopup] = useState(false);
  const [openotppopupafteremail, setopenotppopupafteremail] = useState(false);
  const [openretievepopup, setopenretievepopup] = useState(true);
  const [matchotpretievepopup, setmatchotpretievepopup] = useState(true);

  // ─── Send-mail flow ──────────────────────────────────────────────────────────
  const [sendmailemail, setsendmailemail] = useState("");
  const [errorsendmailemail, seterrorsendmailemail] = useState("");
  const [nextpopupvalue, setnextpopupvalue] = useState("");

  // ─── Search ──────────────────────────────────────────────────────────────────
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [settingdatas, setSettingData] = useState("");
  const [SearchError, setSearchError] = useState("");
  const [defaultValueCode] = useState("");

  // ─── Signup ──────────────────────────────────────────────────────────────────
  const [success, setsuccess] = useState(true);
  const [allerrors, setallerror] = useState({});
  const [customer_type, setcustomer_type] = useState("4");
  const [error_customer_type, seterror_customer_type] = useState("");
  const [signupselectedValue, setSignupSelectedValue] = useState("4");
  const [signupname, setsignupname] = useState("");
  const [signupemail, setsignupemail] = useState("");
  const [signupphone, setsignupphone] = useState("");
  const [signupaddress, setsignupaddress] = useState("");
  const [signupcity, setsignupcity] = useState("");
  const [signupcountry, setsignupcountry] = useState("");
  const [signuplandmark, setsignuplandmark] = useState("");
  const [signuppassword, setsignuppassword] = useState("");
  const [signupcon_password, setsignupcon_password] = useState("");
  const [errorsignupcon_password, seterrorsignupcon_password] = useState("");
  const [errorsignupbusiness_card, seterrorsignupbusiness_card] = useState("");
  const [base64Image, setBase64Image] = useState(null);

  // ─── Mount ───────────────────────────────────────────────────────────────────
  useEffect(() => {
    const showWarning = localStorage.getItem("showInactiveWarning");
    if (showWarning === "true") {
      setShowInactiveModal(true);
      localStorage.removeItem("showInactiveWarning");
    }

    // E-catalog URL
    fetch("https://sbmmarketplace.com/backend/public/api/ecatalog")
      .then((res) => res.json())
      .then((d) => {
        if (d?.success && d?.url) setCatalogUrl(d.url);
      })
      .catch((err) => console.error("Failed to load e-catalog:", err));

    // Cart count
    const fetchCartsDe = async () => {
      try {
        const response = await axios.get(`${apiUrl}/carts`, {
          headers: {
            Authorization: `Bearer ${tokendata?.data?.token}`,
            "Content-Type": "application/json; charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
          },
        });
        setCartItemCount(response.data.data.items);
      } catch {
      } finally {
        setLoading(false);
      }
    };

    // Settings
    const fetchSettingData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/settings`, {
          headers: {
            Authorization: `Bearer ${tokendata?.data?.token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        setSettingData(response.data.data);
      } catch (err) {
        console.error("Error fetching settings:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCartsDe();
    fetchSettingData();

    // FIX: clear interval on unmount so no ghost timers run
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  // ─── Timer ───────────────────────────────────────────────────────────────────
  // FIX #1 (core): always kill the previous interval before creating a new one.
  // This is what was causing quota exhaustion — stacked timers fired resend
  // callbacks simultaneously, each triggering a fresh API call + email.
  const startTimer = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    setSecondsRemaining(180);
    setOtpSent(true);

    timerRef.current = setInterval(() => {
      setSecondsRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          setOtpSent(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // ─── Helpers ─────────────────────────────────────────────────────────────────
  const location2 = useLocation();
  const ref_fun = () => {
    if (location2.pathname.includes("reset-password")) {
      setTimeout(() => {
        const anchor = document.createElement("a");
        anchor.href = "/";
        anchor.target = "_blank";
        anchor.rel = "noopener noreferrer";
        anchor.click();
        window.history.back();
      }, 900);
    }
  };

  const formatMobileNumber = (mobileNumber) => {
    if (mobileNumber && typeof mobileNumber === "string") {
      const lastFour = mobileNumber.slice(-4);
      return "+9" + "*".repeat(mobileNumber.length - 4) + lastFour;
    }
    return mobileNumber;
  };

  const ManageRetriveAndForgot = (val) => setRetriveAndForgot(val);
  const closelastpopups = () => {
    window.location.href = "/";
  };

  // ─── Search ──────────────────────────────────────────────────────────────────
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim() === "") {
      setSearchError(true);
    } else {
      setSearchError(false);
      nvg(`/shop?search=${searchTerm}`);
      window.location.reload();
    }
  };

  // ─── Login ───────────────────────────────────────────────────────────────────
  const handleLogin = async (e) => {
    e.preventDefault();
    let hasError = false;
    if (!email) {
      seterroremail("Email is Required");
      hasError = true;
    } else seterroremail("");
    if (!password) {
      seterrorpassword("Password is Required");
      hasError = true;
    } else seterrorpassword("");
    if (hasError) {
      setBothError("Both are Required");
      return;
    }
    setBothError("");

    try {
      const response = await axios.post(
        `${apiUrl}/login`,
        { email, password },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      if (response?.data?.success === true) {
        storeToken(response.data);
        setlogin(true);
        setUserData(response.data);
        setError("");
        if (response.data.data.status == 0) {
          localStorage.setItem("showInactiveWarning", "true");
        }
        nvg("/cart");
        window.location.reload();
      }
    } catch (err) {
      // FIX #4: never navigate on failed login
      if (err.response?.data?.message) setError(err.response.data.message);
      setLoading(false);
    }
  };

  const handleLoginGuest = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${apiUrl}/login`,
        { email: "S14691", password: "sbmdubai123" },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      if (response?.data?.success === true) {
        storeToken(response.data);
        setlogin(true);
        setUserData(response.data);
        setError("");
        nvg("/");
        window.location.reload();
      }
    } catch (err) {
      if (err.response?.data?.message) setError(err.response.data.message);
    }
  };

  // ─── Form helpers ────────────────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleRadioChange = (val) => setSelectedValue(val);
  const handleSignupRadioChange = (val) => setSignupSelectedValue(val);
  const handleExistVendorChange = (val) => setvendor_code(val);

  const validateForm1 = () => {
    let valid = true;
    const newErrors = {};
    if (!formData.vendor_code) {
      newErrors.vendor_code = "Vendor code is required";
      valid = false;
    }
    if (selectedValue === "mobile") {
      if (!formData.country) {
        newErrors.country = "Country is required";
        valid = false;
      }
      if (!formData.mobile) {
        newErrors.mobile = "Mobile is required";
        valid = false;
      }
    } else if (selectedValue === "email") {
      if (!sendmailemail) {
        newErrors.email = "Email is required";
        valid = false;
      }
    }
    setErrors(newErrors);
    return valid;
  };

  const validateFormmatchotp = () => {
    const newErrors = {};
    if (!formData.otp) newErrors.otp = "OTP is required";
    setErrors(newErrors);
    return !newErrors.otp;
  };

  // ─── Vendor code blur ────────────────────────────────────────────────────────
  const handleBlur = () => matchVendorCode();

  const matchVendorCode = async () => {
    if (!exitsvendor_code) {
      setError("Vendor Code is required");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${apiUrl}/verify-vendor-code`, {
        code: exitsvendor_code,
      });
      if (response.data.success === true) {
        setMobileNumner(response?.data?.data?.mobile);
        setError("");
      }
    } catch (err) {
      if (err.response?.data?.data) {
        setError(err.response.data.data);
        setMobileNumner("");
      }
    } finally {
      setLoading(false);
    }
  };

  // ─── OTP send (core) ─────────────────────────────────────────────────────────
  // FIX #2: isSending guard prevents rapid-click duplicate API calls.
  // Each call was sending a separate email; two clicks = two emails, etc.
  const sendotpCode = async () => {
    if (isSending) return;
    if (!formData.vendor_code) return;

    setIsSending(true);
    setLoading(true);

    const collect = {
      code: formData.vendor_code,
      mobile: formData.country + "" + formData.mobile,
    };
    setnextpopupvalue(collect);

    try {
      const response = await axios.post(`${apiUrl}/send-otp`, collect);
      if (response.data.success === true) {
        setopenotppopup(true);
        setopenretievepopup(false);
        setotpmessage(response.data.message);
        seterror_otp_match("");

        // FIX #1: startTimer clears old interval internally before setting new one
        startTimer();

        if (closeretriveaccess.current) closeretriveaccess.current.click();
        if (closefromemailnextpopup.current)
          closefromemailnextpopup.current.click();
        if (newpop3.current) {
          const modal = new window.bootstrap.Modal(newpop3.current);
          modal.show();
        }
      } else {
        setError(response?.data?.message);
      }
    } catch (err) {
      if (err.response?.data?.data) {
        setError(err.response.data.data);
        setMobileNumner("");
      }
    } finally {
      setIsSending(false);
      setLoading(false);
    }
  };

  const handleRetriveAccess = async (e) => {
    e.preventDefault();
    if (!validateForm1()) return;
    sendotpCode();
  };

  // FIX #2: resend also goes through the same isSending guard
  const handleResendOTPRetriveAccess = () => sendotpCode();

  const handleEmailRetriveAccess = async (e) => {
    e.preventDefault();
    if (!validateForm1()) return;
    if (closeretriveaccess.current) closeretriveaccess.current.click();
    if (newpop.current) newpop.current.click();
    if (fromemailnextpopup.current) {
      const modal = new window.bootstrap.Modal(fromemailnextpopup.current);
      modal.show();
    }
  };

  // ─── OTP verify ──────────────────────────────────────────────────────────────
  const Mobileotpmatch = async () => {
    setLoading(true);
    const collectM = {
      code: formData.vendor_code,
      mobile: formData.country + "" + formData.mobile,
      otp: formData.otp,
    };
    try {
      const response = await axios.post(`${apiUrl}/verify-otp`, collectM);
      if (response.data.success === true) {
        setopenotppopup(false);
        setopenretievepopup(false);
        setotpmessage(response.data.message);
        if (matchotp.current) matchotp.current.click();

        if (sendmailemail !== "") {
          // FIX #3: pass (code, mobile, otp) explicitly — never pass the Event object
          sendmailsubmit(collectM.code, collectM.mobile, collectM.otp);
        } else {
          if (matchotps.current) {
            const modal = new window.bootstrap.Modal(matchotps.current);
            modal.show();
          }
          setLoading(false);
        }
      }
    } catch (err) {
      if (err.response?.data?.data) {
        seterror_otp_match(err.response.data.data);
        setotpmessage("");
      }
      setLoading(false);
    }
  };

  const handleRetriveAccessMatchotp = async (e) => {
    e.preventDefault();
    if (!validateFormmatchotp()) return;
    Mobileotpmatch();
  };

  // ─── Send forgot-password email ───────────────────────────────────────────────
  // FIX #3: function signature is (code, mobile, otp) — explicit params, never an Event.
  // Previously the "SEND MAIL" button called onClick={sendmailsubmit} which passed the
  // click Event as `code`, corrupting all three parameters and causing extra API hits.
  const sendmailsubmit = async (code, mobile, otp) => {
    if (!sendmailemail) {
      seterrorsendmailemail("Email is Required");
      return;
    }
    seterrorsendmailemail("");
    setLoading(true);
    try {
      const response = await axios.post(
        `${apiUrl}/send-forget-password-email`,
        { code, email: sendmailemail, mobile, otp },
        {
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
          },
        },
      );
      if (response.data.success === true) {
        setopenotppopup(false);
        setopenretievepopup(false);
        setmatchotpretievepopup(false);
        setotpmessage(response.data.message);
        if (verifyotp.current) verifyotp.current.click();
        if (emailmsg.current) {
          const modal = new window.bootstrap.Modal(emailmsg.current);
          modal.show();
        }
      }
    } catch (err) {
      console.error("sendmailsubmit error:", err);
    } finally {
      setLoading(false);
    }
  };

  // ─── Signup ──────────────────────────────────────────────────────────────────
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setBase64Image(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const signupsubmit = async () => {
    if (!customer_type) {
      seterror_customer_type("Select customer type is Required");
      return;
    }
    if (signuppassword !== signupcon_password) {
      seterrorsignupcon_password("Password & Confirm Password does not match.");
      return;
    }
    if (signupselectedValue === "3" && !base64Image) {
      seterrorsignupbusiness_card("Please upload business card image.");
      return;
    }

    seterror_customer_type("");
    seterrorsignupcon_password("");
    seterrorsignupbusiness_card("");
    setLoading(true);

    try {
      const formdata = {
        user_role: customer_type,
        name: signupname,
        email: signupemail,
        address: signupaddress,
        city: signupcity,
        country: signupcountry,
        password: signuppassword,
        phone_number: signupphone,
        landmark: signuplandmark,
        business_card: base64Image || "null",
      };
      const response = await axios.post(`${apiUrl}/register`, formdata, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
        },
      });
      if (response.data.success === true) {
        toast.success(<div>{response.data.message}</div>, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        setTimeout(() => window.location.reload(true), 2000);
      }
    } catch (err) {
      setallerror(err.response?.data?.data || {});
      console.error("Signup error:", err);
    } finally {
      setLoading(false);
    }
  };

  // ─── JSX ─────────────────────────────────────────────────────────────────────
  return (
    <header id="header" style={tokendata?.data?.status == 0 ? { paddingTop: "41px" } : {}}>
      {tokendata?.data?.status == 0 && (
        <div style={{
          backgroundColor: "#e65100",
          color: "#fff",
          textAlign: "center",
          padding: "10px 15px",
          fontWeight: "bold",
          fontSize: "14px",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 99999,
          overflow: "hidden",
          height: "auto",
          display: "block"
        }}>
          Your account is currently inactive. You can browse all products but will not be able to place orders. Please Contact Accounts Team for Assistance.
        </div>
      )}
      {loading ? <Loader /> : null}
      <ToastContainer
        style={
          tokendata?.data?.status == 0
            ? { top: "60px", zIndex: 999999 }
            : { zIndex: 999999 }
        }
      />

      {/* ── Main header bar ─────────────────────────────────────────────────── */}
      <div className="main-header px-xl-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-xl-12 col-sm-12">
              <div id="desktop-menu">
                <nav className="navbar justify-content-center navbar-expand-lg navbar-light">
                  <span className="navbar-brand logo" onClick={() => nvg("/")}>
                    {tokendata ? (
                      <img
                        onClick={ref_fun}
                        src={settingdatas.logo}
                        alt={settingdatas.website_name}
                      />
                    ) : (
                      <img
                        onClick={ref_fun}
                        src="https://sbmmarketplace.com/backend/public/uploads/2021/06/logo.png"
                        alt="Vaultex"
                      />
                    )}
                  </span>

                  {/* Search bar */}
                  <div className="search-with-cat search-width custozsearch hideinmobile">
                    <form onSubmit={handleSearchSubmit}>
                      <div className="inner-form">
                        <div className="input-field first-wrap search-container">
                          <input
                            id="search"
                            type="text"
                            placeholder="Search for Products"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className={SearchError ? "error" : ""}
                          />
                        </div>
                        <div className="input-field second-wrap">
                          <button className="btn-search" type="submit">
                            <i className="fa fa-search" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                  {/* Cart — hidden for guest */}
                  {tokendata?.data?.vendor_code !== "S14691" && (
                    <div className="header-cart">
                      <NavLink to="/cart" style={{ textWrap: "nowrap" }}>
                        <img
                          onClick={ref_fun}
                          src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/cart.png`}
                          alt="cart icon"
                        />
                        {tokendata && (
                          <span className="cart-count">
                            {cartitemscount?.length || "0"}
                          </span>
                        )}
                        <span className="cart-heading" onClick={ref_fun}>
                          Cart
                        </span>
                      </NavLink>
                    </div>
                  )}

                  {/* Auth area */}
                  {tokendata ? (
                    <div className="header-right">
                      <Vtheaderright />
                    </div>
                  ) : (
                    <div>
                      <div className="header-right">
                        <div className="user-login">
                          <a href="javascript:void(0);">
                            <i className="fa fa-user" aria-hidden="true" />
                            <span>Login</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  )}

                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarToggleExternalContent"
                    aria-controls="navbarToggleExternalContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Mobile nav ──────────────────────────────────────────────────────── */}
      <div
        className="collapse"
        id="navbarToggleExternalContent"
        data-bs-theme="white"
      >
        <div className="p-3" style={{ backgroundColor: "#059fe2" }}>
          <ul>
            {[
              { to: "/", label: "Home" },
              { to: "/best-seller", label: "Best Sellers" },
              { to: "/new-products", label: "New Products" },
              { to: "/bulk-order", label: "Bulk Order" },
              { to: "/brand", label: "Our Brand" },
              { to: "/offers", label: "Offers" },
            ].map(({ to, label }) => (
              <li className="nav-item" key={to}>
                <NavLink
                  style={{
                    display: "flex",
                    color: "white",
                    padding: "5px 0px",
                  }}
                  to={to}
                  onClick={ref_fun}
                >
                  {label}
                </NavLink>
              </li>
            ))}
            <li className="nav-item">
              {catalogUrl ? (
                <a
                  href={catalogUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    color: "white",
                    padding: "5px 0px",
                  }}
                >
                  E-Catalogue
                </a>
              ) : (
                <span
                  style={{
                    opacity: 0.6,
                    cursor: "default",
                    display: "flex",
                    color: "white",
                    padding: "5px 0px",
                  }}
                >
                  E-Catalogue
                </span>
              )}
            </li>
          </ul>
        </div>
      </div>

      {/* ── Mobile search ───────────────────────────────────────────────────── */}
      <div className="search-with-cat search-width py-2 custozsearch2 showinmobile">
        <form method="POST">
          <div className="inner-form">
            <div className="input-field first-wrap d-flex">
              <input
                id="search2"
                type="text"
                className="searchwidth"
                placeholder="Search for Products"
              />
              <div className="input-field second-wrap searchbtnwidth">
                <button className="btn-search" type="submit">
                  <i className="fa fa-search" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* ── Desktop bottom nav ──────────────────────────────────────────────── */}
      <div className="bottom-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="site-navigation">
                <ul className="text-center">
                  {[
                    { to: "/", label: "Home" },
                    { to: "/best-seller", label: "Best Sellers" },
                    { to: "/new-products", label: "New Products" },
                  ].map(({ to, label }) => (
                    <li className="nav-item" key={to}>
                      <NavLink to={to} onClick={ref_fun}>
                        {label}
                      </NavLink>
                    </li>
                  ))}
                  {tokendata?.data?.vendor_code !== "S14691" && (
                    <li className="nav-item">
                      <NavLink to="/bulk-order" onClick={ref_fun}>
                        Bulk Order
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item">
                    <NavLink to="/brand" onClick={ref_fun}>
                      Our Brand
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/offers" onClick={ref_fun}>
                      Offers
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    {catalogUrl ? (
                      <a
                        href={catalogUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        E-Catalogue
                      </a>
                    ) : (
                      <span style={{ opacity: 0.6, cursor: "default" }}>
                        E-Catalogue
                      </span>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════════════════════
          MODAL 1 — Login
      ════════════════════════════════════════════════════════════════════════ */}
      <div
        className="modal fade"
        id="staticBackdrop"
        ref={loginpopRef}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        style={{ outline: "none", background: "none" }}
      >
        <div className="modal-dialog newwidth">
          <div className="modal-content" style={{ overflow: "hidden" }}>
            <div className="modal-header" style={{ padding: "8px" }}>
              <button
                type="button"
                className="btn-close remove-button"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  background: "#059fe2",
                  color: "#fff",
                  borderRadius: "0px",
                  fontSize: "20px",
                }}
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>

            <form onSubmit={handleLogin}>
              <div className="modal-body">
                <h5 className="sign-text text-center mt-1 pb-3">Sign In</h5>
                {botherror !== "" && (
                  <div className="form-group form-row d-flex justify-content-center">
                    <div className="col-10">
                      <div
                        className="alert alert-danger mx-0"
                        style={{ width: "100%", textAlign: "center" }}
                        role="alert"
                      >
                        Validation Error.
                      </div>
                    </div>
                  </div>
                )}
                {error && (
                  <div className="form-group form-row d-flex justify-content-center">
                    <div className="col-10">
                      <div
                        className="alert alert-danger mx-0"
                        style={{ width: "100%", textAlign: "center" }}
                        role="alert"
                      >
                        {error}
                      </div>
                    </div>
                  </div>
                )}
                <div className="form-group form-row d-flex justify-content-center">
                  <input
                    style={{
                      borderBottom: erroremail !== "" ? "1px solid red" : "",
                    }}
                    id="email"
                    type="text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    name="email"
                    placeholder="Email address or Vendor code*"
                    className="input-areabutton"
                  />
                </div>
                <div className="form-group form-row d-flex justify-content-center mt-3">
                  <input
                    style={{
                      borderBottom: errorpassword !== "" ? "1px solid red" : "",
                    }}
                    id="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type={changepss ? "text" : "password"}
                    name="password"
                    placeholder="Password*"
                    className="input-areabutton"
                  />
                  <span
                    className="icon is-small is-right"
                    onClick={() => setchangepss(!changepss)}
                  >
                    {!changepss ? (
                      <div
                        style={{
                          position: "absolute",
                          right: "72px",
                          bottom: "26px",
                          fontSize: "17px",
                        }}
                      >
                        <AiOutlineEyeInvisible />
                      </div>
                    ) : (
                      <i className="fa fa-solid fa-eye"></i>
                    )}
                  </span>
                </div>
              </div>
              <div className="form-group form-row d-flex justify-content-center mt-2 mb-3">
                <button
                  type="submit"
                  className="btn btn-signup col-9 rounded-0 text-uppercase pt-2 pb-2"
                >
                  Continue
                </button>
              </div>
              <div className="col-12 pb-2">
                <center>OR</center>
              </div>
              <div className="form-group form-row d-flex justify-content-center mt-2 mb-3">
                <button
                  type="button"
                  className="btn btn-signup col-9 rounded-0 text-uppercase pt-2 pb-2"
                  onClick={handleLoginGuest}
                >
                  Signin as Guest
                </button>
              </div>
            </form>

            <div className="col-md-12 col-12">
              <div
                className="row px-2"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                <div className="forgot text-left col-6 mb-3">
                  <a
                    href="javascript:void(0);"
                    className="active"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop2"
                    onClick={() => ManageRetriveAndForgot("retrive_access")}
                  >
                    Retrive Access
                  </a>
                </div>
                <div className="forgot1 text-right col-6 mb-3">
                  <a
                    href="javascript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop2"
                    onClick={() => ManageRetriveAndForgot("forgot_password")}
                  >
                    Forgot Password ?
                  </a>
                </div>
              </div>
            </div>
            <div className="signin-footer pt-3 pb-3 mb-3">
              <div className="signup-text text-center">
                <h6>
                  Don't have an account ?{" "}
                  <a
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModalSignup"
                    href="javascript:void(0)"
                    className="active"
                  >
                    &nbsp;SIGN UP NOW
                  </a>
                </h6>
                <span>
                  By signing up you agree to our{" "}
                  <a
                    href="javascript:void(0);"
                    onClick={() => nvg("/Terms-Conditions")}
                  >
                    Terms of use
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════════════════════
          MODAL 2 — Retrieve Access / Forgot Password
      ════════════════════════════════════════════════════════════════════════ */}
      <div
        className="modal fade"
        ref={newpop}
        id="staticBackdrop2"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        style={{ outline: "none", background: "none", overflow: "auto" }}
      >
        <div className="modal-dialog newwidth">
          <div className="modal-content">
            <div className="modal-header" style={{ borderBottom: "none" }}>
              <button
                ref={closeretriveaccess}
                type="button"
                className="btn-close remove-button"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  background: "#059fe2",
                  color: "#fff",
                  borderRadius: "0px",
                  fontSize: "20px",
                }}
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <h5 className="sign-text text-center mt-1 pb-2">
                  {RetriveAndForgot === "retrive_access"
                    ? "Access Request"
                    : "Forgot Password"}
                </h5>


                <div className="col-lg-10" style={{ marginLeft: "38px" }}>
                  {mobilenumber && (
                    <center>
                      <div className="alert alert-success">
                        Use&nbsp;{formatMobileNumber(mobilenumber)}&nbsp;mobile
                        number.
                      </div>
                    </center>
                  )}
                  {error && (
                    <center>
                      <div
                        className="alert alert-error"
                        style={{ fontSize: "14px" }}
                      >
                        {error}
                      </div>
                    </center>
                  )}
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    {/* Radio buttons */}
                    <div
                      className="form-group form-row redbutton"
                      style={{ marginLeft: "12px" }}
                    >
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          value="mobile"
                          onClick={(e) => handleRadioChange(e.target.value)}
                          onChange={() => setMobileNumner("")}
                          checked={selectedValue === "mobile"}
                        />
                        <label className="form-check-label">Mobile</label>
                      </div>
                      <span style={{ margin: "0 10px" }}>OR</span>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          value="email"
                          onClick={(e) => handleRadioChange(e.target.value)}
                          onChange={() => setMobileNumner("")}
                          checked={selectedValue === "email"}
                        />
                        <label className="form-check-label">Email</label>
                      </div>
                    </div>

                    {/* Vendor code */}
                    <div className="col-lg-12">
                      <div className="form-group form-row d-flex justify-content-center mt-3">
                        <input
                          style={{
                            borderBottom: errors.vendor_code
                              ? "1px solid red"
                              : "",
                          }}
                          type="text"
                          name="vendor_code"
                          placeholder="Enter Vendor Code*"
                          className="input-areabutton"
                          defaultValue={defaultValueCode}
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleExistVendorChange(e.target.value);
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>

                    {/* Email or Mobile */}
                    {selectedValue === "email" ? (
                      <div className="col-lg-12">
                        <div className="form-group form-row d-flex justify-content-center mt-3">
                          <input
                            style={{
                              borderBottom: errors.email ? "1px solid red" : "",
                            }}
                            type="email"
                            name="email"
                            placeholder="Enter Email*"
                            className="input-areabutton"
                            value={sendmailemail}
                            onChange={(e) => setsendmailemail(e.target.value)}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="col-lg-12">
                        <div className="form-group form-row d-flex justify-content-center mt-3">
                          <select
                            name="country"
                            className="form-select"
                            aria-label="Country code"
                            style={{ width: "80%" }}
                            value={formData.country}
                            onChange={handleChange}
                          >
                            <option value="">Select Country Code</option>
                            <option value="+971">
                              United Arab Emirates (+971)
                            </option>
                            <option value="+91">India (+91)</option>
                            <option value="+1">United States (+1)</option>
                            <option value="+44">United Kingdom (+44)</option>
                            <option value="+966">Saudi Arabia (+966)</option>
                            <option value="+974">Qatar (+974)</option>
                            <option value="+965">Kuwait (+965)</option>
                            <option value="+968">Oman (+968)</option>
                            <option value="+973">Bahrain (+973)</option>
                          </select>
                        </div>
                        <div className="form-group form-row d-flex justify-content-center mt-3">
                          <input
                            style={{
                              borderBottom: errors.mobile
                                ? "1px solid red"
                                : "",
                            }}
                            type="number"
                            name="mobile"
                            placeholder="Enter Mobile*"
                            className="input-areabutton"
                            value={formData.mobile}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    )}
                    <br />
                  </div>

                  <div className="form-group form-row d-flex justify-content-center mt-2 mb-4">
                    {/* FIX #2: disabled while isSending prevents duplicate email sends */}
                    <button
                      type="button"
                      onClick={
                        selectedValue === "mobile"
                          ? handleRetriveAccess
                          : handleEmailRetriveAccess
                      }
                      disabled={isSending}
                      className="btn btn-signup col-9 rounded-0 text-uppercase pt-2 pb-2"
                    >
                      {isSending
                        ? "Sending..."
                        : selectedValue === "mobile"
                          ? "SEND OTP"
                          : "NEXT"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════════════════════
          MODAL 3 — Enter & verify OTP
      ════════════════════════════════════════════════════════════════════════ */}
      <div
        id="staticBackdrop8"
        className={openotppopup ? "modal fade show" : "modal fade"}
        ref={newpop3}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-hidden="true"
        style={{ outline: "none", background: "none", overflow: "auto" }}
      >
        <div className="modal-dialog newwidth">
          <div className="modal-content">
            <div className="modal-header" style={{ borderBottom: "none" }}>
              <button
                type="button"
                className="btn-close remove-button"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={matchotp}
                style={{
                  background: "#059fe2",
                  color: "#fff",
                  borderRadius: "0px",
                  fontSize: "20px",
                }}
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <form onSubmit={handleRetriveAccessMatchotp}>
              <div className="row">
                <div className="col-lg-1"></div>
                <div className="col-lg-10">
                  {otpmessage && (
                    <center>
                      <div className="alert alert-success">{otpmessage}</div>
                    </center>
                  )}
                  {error_otp_match && (
                    <center>
                      <div
                        className="alert alert-error"
                        style={{ fontSize: "14px" }}
                      >
                        {error_otp_match}
                      </div>
                    </center>
                  )}
                </div>
                <div className="col-lg-1"></div>
              </div>
              <div className="modal-body">
                <h5 className="sign-text text-center mt-1 pb-2">
                  {RetriveAndForgot === "retrive_access"
                    ? "Access Request"
                    : "Forgot Password"}
                </h5>

                <div className="row">
                  <div className="col-lg-12">
                    <div className="col-lg-12">
                      <div className="form-group form-row d-flex justify-content-center mt-3">
                        <input
                          type="number"
                          name="otp"
                          placeholder="Enter OTP*"
                          className="input-areabutton"
                          value={formData.otp}
                          onChange={handleChange}
                          style={{
                            backgroundColor: "rgb(232, 240, 254)",
                            border: errors.otp
                              ? "1px solid red"
                              : "1px solid #ccc",
                          }}
                        />
                      </div>
                      {secondsRemaining > 0 && (
                        <center>
                          <p style={{ color: "red", lineHeight: "21px" }}>
                            OTP will expire in {secondsRemaining} seconds
                          </p>
                        </center>
                      )}
                    </div>
                    <br />
                  </div>
                  <div className="form-group form-row d-flex justify-content-center mt-2 mb-4">
                    {secondsRemaining === 0 ? (
                      // FIX #2: disabled while resending
                      <button
                        type="button"
                        onClick={handleResendOTPRetriveAccess}
                        disabled={isSending}
                        className="btn btn-signup col-9 rounded-0 text-uppercase pt-2 pb-2 mb-4"
                      >
                        {isSending ? "Sending..." : "RESEND OTP"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-signup col-9 rounded-0 text-uppercase pt-2 pb-2 mb-4"
                      >
                        {sendmailemail !== ""
                          ? "Verify OTP And Send Mail"
                          : "VERIFY OTP"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════════════════════
          MODAL 4 — Enter email after OTP verified (mobile flow → forgot password)
      ════════════════════════════════════════════════════════════════════════ */}
      {matchotpretievepopup && (
        <div
          id="staticBackdrop9"
          className={openotppopupafteremail ? "modal fade show" : "modal fade"}
          ref={matchotps}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex={-1}
          aria-hidden="true"
          style={{ outline: "none", background: "none", overflow: "auto" }}
        >
          <div className="modal-dialog newwidth">
            <div className="modal-content">
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <button
                  type="button"
                  className="btn-close remove-button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  ref={verifyotp}
                  style={{
                    background: "#059fe2",
                    color: "#fff",
                    borderRadius: "0px",
                    fontSize: "20px",
                  }}
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
              <div className="row">
                <div className="col-lg-1"></div>
                <div className="col-lg-10">
                  {otpmessage && (
                    <center>
                      <div className="alert alert-success">{otpmessage}</div>
                    </center>
                  )}
                </div>
                <div className="col-lg-1"></div>
              </div>
              <div className="modal-body">
                <h5 className="sign-text text-center mt-1 pb-2">
                  {RetriveAndForgot === "retrive_access"
                    ? "Access Request"
                    : "Forgot Password"}
                </h5>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="col-lg-12">
                      <div className="form-group form-row d-flex justify-content-center mt-1">
                        <input
                          type="email"
                          name="sendmailemail"
                          placeholder="Enter email*"
                          className="input-areabutton"
                          value={sendmailemail}
                          onChange={(e) => setsendmailemail(e.target.value)}
                          style={{
                            backgroundColor: "rgb(232, 240, 254)",
                            border: "1px solid #ccc",
                          }}
                        />
                      </div>
                      {errorsendmailemail !== "" && (
                        <center>
                          <p style={{ color: "red" }}>{errorsendmailemail}</p>
                        </center>
                      )}
                    </div>
                    <br />
                  </div>
                  <div className="form-group form-row d-flex justify-content-center mt-2 mb-4">
                    {/* FIX #3: arrow function passes explicit params instead of the click Event */}
                    <button
                      type="button"
                      onClick={() =>
                        sendmailsubmit(
                          formData.vendor_code,
                          formData.country + formData.mobile,
                          formData.otp,
                        )
                      }
                      className="btn btn-signup col-9 rounded-0 text-uppercase pt-2 pb-2 mb-4"
                    >
                      SEND MAIL
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ════════════════════════════════════════════════════════════════════════
          MODAL 5 — Mail sent confirmation
      ════════════════════════════════════════════════════════════════════════ */}
      <div
        id="staticBackdrop10"
        className={openotppopupafteremail ? "modal fade" : "modal fade show"}
        ref={emailmsg}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-hidden="true"
        style={{ outline: "none", background: "none", overflow: "auto" }}
      >
        <div className="modal-dialog newwidth">
          <div className="modal-content">
            <div className="modal-header" style={{ borderBottom: "none" }}>
              <button
                type="button"
                className="btn-close remove-button"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closelastpopups}
                style={{
                  background: "#059fe2",
                  color: "#fff",
                  borderRadius: "0px",
                  fontSize: "20px",
                }}
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div className="modal-body">
              <h5 className="sign-text text-center mt-1 pb-2">
                {RetriveAndForgot === "retrive_access"
                  ? "Access Request"
                  : "Forgot Password"}
              </h5>

              {/* ✅ SUCCESS MESSAGE */}
              {otpmessage && (
                <div className="text-center">
                  <div className="alert alert-success">{otpmessage}</div>
                </div>
              )}

              {/* ✅ USER GUIDANCE */}
              <div className="text-center mt-2">
                <p style={{ fontSize: "14px", color: "#555" }}>
                  Please check your email for the password reset link.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════════════════════
          MODAL 6 — Sign Up
      ════════════════════════════════════════════════════════════════════════ */}
      <div
        className="modal fade"
        id="exampleModalSignup"
        ref={signup}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        style={{ outline: "none", background: "none", overflow: "auto" }}
      >
        <div className="modal-dialog modal-dialog-centered popaddresswidth">
          <div className="modal-content" style={{ borderRadius: "0px" }}>
            <div
              className="modal-header"
              style={{ padding: "8px", border: "none" }}
            >
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ background: "#059fe2", borderRadius: "0px" }}
              >
                <span style={{ color: "white" }}>
                  <i className="fa-solid fa-xmark"></i>
                </span>
              </button>
            </div>
            <div className="modal-body py-0">
              <div className="row">
                <div className="col-12 pb-3">
                  <h5 className="title451 text-center">Sign Up</h5>
                </div>
              </div>
              <div className="container-fluid" style={{ width: "100%" }}>
                <div className="form-group form-row redbutton">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="customer_type"
                      value="3"
                      style={{ position: "relative" }}
                      onClick={(e) => handleSignupRadioChange(e.target.value)}
                      onChange={(e) => setcustomer_type(e.target.value)}
                    />
                    <label
                      className="form-check-label"
                      style={{ marginTop: "3px" }}
                    >
                      Trading Customer
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="customer_type"
                      value="4"
                      style={{ position: "relative" }}
                      onClick={(e) => handleSignupRadioChange(e.target.value)}
                      onChange={(e) => setcustomer_type(e.target.value)}
                      checked={signupselectedValue === "4"}
                    />
                    <label
                      className="form-check-label"
                      style={{ marginTop: "3px" }}
                    >
                      Other Customer
                    </label>
                  </div>
                </div>
                {error_customer_type !== "" && (
                  <center>
                    <p style={{ color: "red" }}>{error_customer_type}</p>
                  </center>
                )}
                <br />
                {allerrors.email && (
                  <div className="col-12" style={{ width: "100%" }}>
                    <div
                      className="alert alert-danger mx-0"
                      style={{ width: "100%", textAlign: "center" }}
                      role="alert"
                    >
                      {allerrors.email}
                    </div>
                  </div>
                )}

                <div className="row customrow" style={{ width: "100%" }}>
                  <div className="form-group col-md-6 pb-lg-0 pb-2 col-sm-6 col-xs-12 px-2">
                    <label className="acounttitle tilte541 mb-2">
                      Your Name*
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      style={{ borderRadius: "0px" }}
                      placeholder="Enter Your First Name"
                      value={signupname}
                      onChange={(e) => setsignupname(e.target.value)}
                    />
                    {allerrors.name && (
                      <p style={{ color: "red" }}>{allerrors.name}</p>
                    )}
                  </div>
                  <div className="form-group col-md-6 col-sm-6 col-xs-12 px-2">
                    <label className="acounttitle tilte541 mb-2">
                      Email Address*
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      style={{ borderRadius: "0px" }}
                      placeholder="Enter Your Email"
                      value={signupemail}
                      onChange={(e) => setsignupemail(e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-6 col-sm-6 col-xs-12 mt-3 px-2">
                    <label className="acounttitle tilte541 mb-2">
                      Phone Number*
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      style={{ borderRadius: "0px" }}
                      placeholder="Enter Your number"
                      value={signupphone}
                      onChange={(e) => setsignupphone(e.target.value)}
                    />
                    {allerrors.phone_number && (
                      <p style={{ color: "red" }}>{allerrors.phone_number}</p>
                    )}
                  </div>
                  <div className="form-group col-12 mt-3 px-2">
                    <label className="acounttitle tilte541 mb-2">
                      Address*
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      style={{ borderRadius: "0px", height: "55px" }}
                      placeholder="Enter Your address"
                      value={signupaddress}
                      onChange={(e) => setsignupaddress(e.target.value)}
                    />
                    {allerrors.address && (
                      <p style={{ color: "red" }}>{allerrors.address}</p>
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-4 mt-3 px-2">
                    <label className="acounttitle tilte541 mb-2">
                      City/ Town/ District*
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      style={{ borderRadius: "0px" }}
                      placeholder="Enter Your city"
                      value={signupcity}
                      onChange={(e) => setsignupcity(e.target.value)}
                    />
                    {allerrors.city && (
                      <p style={{ color: "red" }}>{allerrors.city}</p>
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-4 mt-3 px-2">
                    <label className="acounttitle tilte541 mb-2">
                      Country*
                    </label>
                    <select
                      className="form-select"
                      style={{ borderRadius: "0px" }}
                      value={signupcountry}
                      onChange={(e) => setsignupcountry(e.target.value)}
                    >
                      <option value="">Select Country</option>
                      <option value="United Arab Emirates">
                        United Arab Emirates
                      </option>
                      <option value="India">India</option>
                      <option value="United States">United States</option>
                      <option value="United Kingdom">United Kingdom</option>
                      <option value="Saudi Arabia">Saudi Arabia</option>
                      <option value="Qatar">Qatar</option>
                      <option value="Kuwait">Kuwait</option>
                      <option value="Oman">Oman</option>
                      <option value="Bahrain">Bahrain</option>
                    </select>
                    {allerrors.country && (
                      <p style={{ color: "red" }}>{allerrors.country}</p>
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-4 mt-3 px-2">
                    <label className="acounttitle tilte541 mb-2">
                      Landmark (Optional)
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      style={{ borderRadius: "0px" }}
                      placeholder="Enter Your Landmark (Optional)"
                      value={signuplandmark}
                      onChange={(e) => setsignuplandmark(e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-6 col-sm-6 col-xs-12 mt-3 px-2">
                    <label className="acounttitle tilte541 mb-2">
                      Password*
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      style={{ borderRadius: "0px" }}
                      placeholder="Enter Your password"
                      value={signuppassword}
                      onChange={(e) => setsignuppassword(e.target.value)}
                    />
                    {allerrors.password && (
                      <p style={{ color: "red" }}>{allerrors.password}</p>
                    )}
                  </div>
                  <div className="form-group col-md-6 col-sm-6 col-xs-12 mt-3 px-2">
                    <label className="acounttitle tilte541 mb-2">
                      Confirm Password*
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      style={{ borderRadius: "0px" }}
                      placeholder="Enter Your confirm password"
                      value={signupcon_password}
                      onChange={(e) => setsignupcon_password(e.target.value)}
                    />
                    {errorsignupcon_password !== "" && (
                      <p style={{ color: "red" }}>{errorsignupcon_password}</p>
                    )}
                  </div>
                  {signupselectedValue === "3" && (
                    <div className="form-group col-md-6 col-sm-6 col-xs-12 mt-3 px-2">
                      <label className="acounttitle tilte541 mb-2">
                        Business card*
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control input-area"
                        onChange={handleImageChange}
                      />
                      {errorsignupbusiness_card !== "" && (
                        <p style={{ color: "red" }}>
                          {errorsignupbusiness_card}
                        </p>
                      )}
                    </div>
                  )}
                  <div className="form-group col-12 mt-3 px-2 pb-2">
                    <button
                      type="button"
                      className="btn sendotpbtn"
                      style={{
                        border: "2px solid #059fe2",
                        borderRadius: "0px",
                        width: "100%",
                      }}
                      onClick={signupsubmit}
                    >
                      SIGN UP
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════════════════════
          MODAL 7 — Email flow: country + mobile → SEND OTP
      ════════════════════════════════════════════════════════════════════════ */}
      <div
        className="modal fade"
        ref={fromemailnextpopup}
        id="staticBackdrop90"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel90"
        aria-hidden="true"
        style={{ outline: "none", background: "none", overflow: "auto" }}
      >
        <div className="modal-dialog newwidth">
          <div className="modal-content">
            <div className="modal-header" style={{ borderBottom: "none" }}>
              <button
                ref={closefromemailnextpopup}
                type="button"
                className="btn-close remove-button"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  background: "#059fe2",
                  color: "#fff",
                  borderRadius: "0px",
                  fontSize: "20px",
                }}
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <form>
              <div className="row">
                <div className="col-lg-1"></div>
                <div className="col-lg-10">
                  {mobilenumber && (
                    <center>
                      <div className="alert alert-success">
                        Use&nbsp;{formatMobileNumber(mobilenumber)}&nbsp;mobile
                        number.
                      </div>
                    </center>
                  )}
                  {error && (
                    <center>
                      <div
                        className="alert alert-error"
                        style={{ fontSize: "14px" }}
                      >
                        {error}
                      </div>
                    </center>
                  )}
                </div>
                <div className="col-lg-1"></div>
              </div>
              <div className="modal-body">
                <h5 className="sign-text text-center mt-1 pb-2">
                  {RetriveAndForgot === "retrive_access"
                    ? "Access Request"
                    : "Forgot Password"}
                </h5>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="col-lg-12">
                      <div className="form-group form-row d-flex justify-content-center mt-3">
                        <select
                          name="country"
                          className="form-select"
                          aria-label="Country code"
                          style={{ width: "80%" }}
                          value={formData.country}
                          onChange={handleChange}
                        >
                          <option value="">Select Country Code</option>
                          <option value="+971">
                            United Arab Emirates (+971)
                          </option>
                          <option value="+91">India (+91)</option>
                          <option value="+1">United States (+1)</option>
                          <option value="+44">United Kingdom (+44)</option>
                          <option value="+966">Saudi Arabia (+966)</option>
                          <option value="+974">Qatar (+974)</option>
                          <option value="+965">Kuwait (+965)</option>
                          <option value="+968">Oman (+968)</option>
                          <option value="+973">Bahrain (+973)</option>
                        </select>
                      </div>
                      {errors.country && (
                        <center>
                          <div className="error">{errors.country}</div>
                        </center>
                      )}
                      <div className="form-group form-row d-flex justify-content-center mt-3">
                        <input
                          type="number"
                          name="mobile"
                          placeholder="Enter Mobile*"
                          className="input-areabutton"
                          value={formData.mobile}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.mobile && (
                        <center>
                          <div className="error">{errors.mobile}</div>
                        </center>
                      )}
                    </div>
                    <br />
                  </div>
                  <div className="form-group form-row d-flex justify-content-center mt-2 mb-4">
                    {/* FIX #2: disabled while isSending */}
                    <button
                      type="button"
                      onClick={handleRetriveAccess}
                      disabled={isSending}
                      className="btn btn-signup col-9 rounded-0 text-uppercase pt-2 pb-2 mb-4"
                    >
                      {isSending ? "Sending..." : "SEND OTP"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {showInactiveModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 100000 }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '600px' }}>
            <div className="modal-content" style={{ border: 'none', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
              <div className="modal-header" style={{ backgroundColor: '#e65100', color: '#fff', borderBottom: 'none', padding: '20px' }}>
                <h5 className="modal-title w-100 text-center" style={{ fontWeight: 'bold', fontSize: '22px', margin: 0 }}>⚠️ Account Inactive</h5>
              </div>
              <div className="modal-body text-center" style={{ padding: '40px 30px', fontSize: '18px', lineHeight: '1.6', color: '#333' }}>
                Your account is currently inactive. You can browse all products but will not be able to place orders.
                <br /><br />
                <strong style={{ color: '#e65100' }}>Please Contact Accounts Team for Assistance.</strong>
              </div>
              <div className="modal-footer" style={{ borderTop: 'none', justifyContent: 'center', paddingBottom: '30px' }}>
                <button
                  type="button"
                  className="btn text-uppercase"
                  style={{ backgroundColor: '#e65100', color: '#fff', padding: '12px 40px', fontWeight: 'bold', borderRadius: '6px', border: 'none', fontSize: '16px', cursor: 'pointer' }}
                  onClick={() => setShowInactiveModal(false)}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
